var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppBar'),_c('v-main',[_c('v-container',[_c('h2',{staticClass:"text-h4"},[_vm._v("Page Not Found!")]),_c('p',[_vm._v("This page does not exist. Please navigate back using the browser's 'back' button or "),_c('a',{attrs:{"href":"/"}},[_vm._v("go to the homepage.")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }